import { render, staticRenderFns } from "./LogoComponent.vue?vue&type=template&id=612c0656&scoped=true&"
import script from "./LogoComponent.vue?vue&type=script&lang=js&"
export * from "./LogoComponent.vue?vue&type=script&lang=js&"
import style0 from "./LogoComponent.vue?vue&type=style&index=0&id=612c0656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612c0656",
  null
  
)

export default component.exports